import {useEffect, useRef} from "react";
import {Chart} from "chart.js/auto";
import {calculateVisualScore} from "../utils/analysisFunctions";


const AnalysisChart = ({data, onPointClick}) => {
    const chartRef = useRef(null);
    const canvasRef = useRef(null)
    
    useEffect(() => {
        if(chartRef.current) {
            chartRef.current.destroy();
        }

        const displayScores = data.map((evalDiff) => calculateVisualScore(evalDiff))

        chartRef.current = new Chart(
            canvasRef.current.getContext("2d"),
            {
                type: 'line',
                options: {
                    animation: false,
                    plugins: {
                        legend: {
                            display: false
                        },
                        tooltip: {
                            callbacks: {
                                label: function (context) {
                                    let index = context.dataIndex;
                                    return data[index];
                                }
                            }
                        }
                    },
                    scales: {
                        x: {
                            grid: {
                                display: false
                            }
                        },
                        y: {
                            min: -110,
                            max: 110,
                            grid: {
                                lineWidth: (ctx) => ctx.tick.value === 0 ? 1 : 0,
                            },
                            ticks: {
                                callback: (value) => (value === 0 ? "0" : "")
                            }
                        }
                    },
                    onClick: (event, elements) => {
                        if(elements.length > 0) {
                            const element = elements[0];
                            const index = element.index;
                            onPointClick(index)
                        }
                    },
                    onHover: (event, elements) => {
                        const canvas = event.native?.target;
                        if(canvas) {
                            canvas.style.cursor = elements.length > 0 ? 'pointer' : 'default';
                        }
                    }
                },
                data: {
                    //Stupid - but it needs labels apparently
                    labels: displayScores.map(() => ""),
                    datasets: [
                        {
                            data: displayScores,
                            tension: 0.2,
                            borderColor: "#FFCCD5"
                        }
                    ]
                }
            }
        )
    }, [data]);

    return (
        <canvas id="analysisChart" ref={canvasRef}/>
    )
}

export default AnalysisChart;